<template>
  
     <div class="list-form-triple">
            <div class="list-form-item">
                <Checkbox v-model="checked"
                :disabled="disabled"
                >
                <Ellipsis :text="destination.details.name"  :length="20"/>
                </Checkbox>
            </div>
            <div class="list-form-item">
                <div class="text-label">
                    REPORTED AT
                </div>
                <div>
                  <Date-picker
                    v-model="reported"
                    type="datetime"
                    :picker-options="reportedOption"
                    format="dd-MM-yyyy hh:mmA"
                    placeholder="Select"
                    @change="onReported"
                    :disabled="disabled"
                    :clearable="this.destination.reported_at ? false:true"
                    :default-time="defaultTime"
                  >
                  </Date-picker>
                </div>
            </div>
            <div class="list-form-item">
                <div class="text-label">
                    POD DATE
                </div>
                <div>
                  <Date-picker
                    v-model="released"
                    type="datetime"
                    @change="onReleased"
                    :picker-options="releaseOption"
                    format="dd-MM-yyyy hh:mmA"
                    placeholder="Select"
                    :disabled="disabled"
                    :clearable="this.destination.release_at ? false:true"
                    :default-time="defaultTime"
                  >
                  </Date-picker>
                </div>
            </div>
      </div>
</template>
<script>
export default {
  props: ['destination', 'maxGateTruckOutDate', 'getBackDateConfig'],

  computed:{
    disabled(destination) {
      return !!(destination.reported_at && destination.release_at);
    },
    allowReportedToBackDate() {
      return this.getBackDateConfig  && this.getBackDateConfig.reported_date ;
    },
    allowReleaseToBackDate() {
      return this.getBackDateConfig  && this.getBackDateConfig.release_date;
    },
  },
  data(){
    const arrivedTime = this.destination.arrived_at;
    const maxGateTruckOutDateTime = this.maxGateTruckOutDate;
    const reportedDateAllow = this.getBackDateConfig && this.getBackDateConfig.reported_date;
    const releaseDateAllow = this.getBackDateConfig && this.getBackDateConfig.release_date;
    const currentDate = new Date();
    return {
      reported: null,
      released: null,
      checked: false,
      defaultTime: `${currentDate.getHours()}:${currentDate.getMinutes()}:00`,
      payload: {
        destination_id: null,
        reported_at: null,
        release_at: null,
      },
      reportedOption: {
        disabledDate(time) {
        if (reportedDateAllow) {
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date();
        }
        return time.getTime() > Date.now() ||
            time.getTime() < new Date(maxGateTruckOutDateTime).getTime() - 8.64e7;
        },
      },
      releaseOption: {
        disabledDate(time) {
          if (releaseDateAllow) {
              return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date();
          }
          if (!arrivedTime) {
              return time.getTime() > Date.now() ||
              time.getTime() < new Date(maxGateTruckOutDateTime).getTime() - 8.64e7;
          }
          return time.getTime() > new Date() ||
            time.getTime() < new Date(arrivedTime).getTime() - 8.64e7;
        }, 
      }
    }
  },
  created() {
    this.payload.destination_id = this.destination.location_id;
    this.reported = this.destination && this.destination.reported_at ? new Date(this.destination.reported_at) : '';
    this.released = this.destination && this.destination.release_at ? new Date(this.destination.release_at) : '';
  },
  methods:{
    onReported(date) {
      this.payload.reported_at =  date;
      this.checked = true;
      const keys = Object.keys(this.payload);
      const res = {};
      keys.forEach((key) => {
        if (this.payload[key]) {
          res[key] = this.payload[key];
        }
      });
      this.$emit('changeDate', res);
    },

    onReleased(date) {
      this.checked = true;
      this.payload.release_at = date;
      const keys = Object.keys(this.payload);
      const res = {};
      keys.forEach((key) => {
        if (this.payload[key]) {
          res[key] = this.payload[key];
        }
      });
      this.$emit('changeDate', res);
    },  
  }
}
</script>